import { chakra } from "@chakra-ui/react";

export const Label = chakra("label", {
  baseStyle: { display: "flex", flexDirection: "column", gap: "4px" },
});

export const CustomForm = chakra("form", {
  baseStyle: { display: "flex", flexDirection: "column", gap: "12px" },
});
